import { render, staticRenderFns } from "./RateRow.vue?vue&type=template&id=3d9c0447&scoped=true"
import script from "./RateRow.vue?vue&type=script&lang=js"
export * from "./RateRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9c0447",
  null
  
)

export default component.exports